import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4af8eaf0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  class: "flex-v-center"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h2", null, "企业设置", -1);
});

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("a", {
    class: "redirect",
    href: '/console'
  }, "返回概览页", -1);
});

var _hoisted_4 = [_hoisted_2, _hoisted_3];
var _hoisted_5 = {
  key: 1
};
var _hoisted_6 = {
  key: 2,
  class: "company-detail"
};
var _hoisted_7 = {
  class: "menus"
};
var _hoisted_8 = {
  class: "company-switch"
};
var _hoisted_9 = ["title"];

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "switch-company"
  }, [/*#__PURE__*/_createElementVNode("i", {
    class: "iconfont iconswitch-line change-company"
  }), /*#__PURE__*/_createTextVNode("切换 ")], -1);
});

var _hoisted_11 = {
  class: "company-list"
};
var _hoisted_12 = ["onClick"];
var _hoisted_13 = ["title"];

var _hoisted_14 = /*#__PURE__*/_createTextVNode(" 基本资料 ");

var _hoisted_15 = /*#__PURE__*/_createTextVNode(" 业务管理 ");

var _hoisted_16 = /*#__PURE__*/_createTextVNode("产品与服务");

var _hoisted_17 = {
  class: "app"
};
var _hoisted_18 = {
  key: 0,
  class: "tag opened"
};
var _hoisted_19 = {
  key: 1,
  class: "tag expiring"
};

var _hoisted_20 = /*#__PURE__*/_createTextVNode(" 账号与资源 ");

var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "app"
  }, "成员列表", -1);
});

var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "app"
  }, "邀请列表", -1);
});

var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "app"
  }, "空间列表", -1);
});

var _hoisted_24 = {
  class: "detail"
};
import { ref, reactive, computed, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { cloneDeep } from 'lodash';
import { useRoute, useRouter } from 'vue-router';
import CompanyService from '@/api/company';
import { ElMessage } from 'element-plus';
import { updateCompanyTip } from '@/config/constant';
import { cloudAppInfoMap } from '@/config/company';
import { dispatchAction } from '@/store/utils';
import { genHrefOpenUrlNoDecode } from '@/utils/login';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var _window$AppConfig;

    var store = useStore();
    var route = useRoute();
    var router = useRouter();
    var corporationId = ref('');
    var selectedKey = ref('Basic');

    var _ref = ((_window$AppConfig = window.AppConfig) === null || _window$AppConfig === void 0 ? void 0 : _window$AppConfig.corporation) || {},
        _ref$showActivateTag = _ref.showActivateTag,
        showActivateTag = _ref$showActivateTag === void 0 ? false : _ref$showActivateTag,
        _ref$hideUserInviteRo = _ref.hideUserInviteRoute,
        hideUserInviteRoute = _ref$hideUserInviteRo === void 0 ? false : _ref$hideUserInviteRo,
        _ref$hideUserListRout = _ref.hideUserListRoute,
        hideUserListRoute = _ref$hideUserListRout === void 0 ? false : _ref$hideUserListRout,
        _ref$hideSwitchCorpor = _ref.hideSwitchCorporation,
        hideSwitchCorporation = _ref$hideSwitchCorpor === void 0 ? false : _ref$hideSwitchCorpor,
        _ref$showBusiness = _ref.showBusiness,
        showBusiness = _ref$showBusiness === void 0 ? true : _ref$showBusiness,
        _ref$onlyAdminSetting = _ref.onlyAdminSetting,
        onlyAdminSetting = _ref$onlyAdminSetting === void 0 ? false : _ref$onlyAdminSetting,
        _ref$showProductsOnCl = _ref.showProductsOnCloud,
        showProductsOnCloud = _ref$showProductsOnCl === void 0 ? false : _ref$showProductsOnCl;

    var companyData = reactive({
      companyList: []
    });
    var isInMicroApp = ref(window.__MICRO_APP_ENVIRONMENT__);
    var appList = computed(function () {
      var originalAppList = cloneDeep(store.state.company.appList);

      if (isInMicroApp.value) {
        var _window$microApp$getD = window.microApp.getData(),
            globalAPI = _window$microApp$getD.globalAPI;

        originalAppList = originalAppList.filter(function (app) {
          var _globalAPI$micro$getA, _globalAPI$micro$getA2;

          var appName = app.appName.toLowerCase();
          var appNameForMicroApp = (_globalAPI$micro$getA = globalAPI.micro.getAppConfig(appName)) === null || _globalAPI$micro$getA === void 0 ? void 0 : (_globalAPI$micro$getA2 = _globalAPI$micro$getA.sidebar) === null || _globalAPI$micro$getA2 === void 0 ? void 0 : _globalAPI$micro$getA2.appName;

          if (appNameForMicroApp) {
            app.appName = appNameForMicroApp;
            return true;
          }

          return false;
        });
      }

      if (!showProductsOnCloud) return originalAppList; // 按照云上侧边边栏 app 列表顺序排序

      var order = Object.keys(cloudAppInfoMap).reduce(function (result, name, index) {
        result[name] = index;
        return result;
      }, {});
      originalAppList.sort(function (next, prev) {
        if (!order[next.appKey]) return 1;
        return order[next.appKey] > order[prev.appKey] ? 1 : -1;
      });
      return originalAppList.filter(function (app) {
        return !!cloudAppInfoMap[app.appKey];
      });
    });
    var detail = computed(function () {
      return store.state.company.detail;
    });
    var isAdmin = computed(function () {
      return store.state.company.isAdmin;
    });
    var userDetail = computed(function () {
      return store.state.user.userDetail;
    }); // 云上版本需要支持返回控制台

    var isInCloud = ref(window.AppConfig.isCloudVersion);
    watchEffect(function () {
      var _route$params;

      if ((_route$params = route.params) !== null && _route$params !== void 0 && _route$params.type) {
        selectedKey.value = route.params.type.toString();
      } else {
        var _route$params$appKey, _route$name;

        selectedKey.value = ((_route$params$appKey = route.params.appKey) === null || _route$params$appKey === void 0 ? void 0 : _route$params$appKey.toString()) || ((_route$name = route.name) === null || _route$name === void 0 ? void 0 : _route$name.toString()) || '';
      }

      console.log(selectedKey.value);
    }); // 获取通过的公司列表

    var getCompanyList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _data$data;

        var data, _data$data$result;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return CompanyService.queryManagerCroporation();

              case 2:
                data = _context.sent;

                if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                  companyData.companyList = (_data$data$result = data.data.result) === null || _data$data$result === void 0 ? void 0 : _data$data$result.filter(function (item) {
                    return (item === null || item === void 0 ? void 0 : item.corporation_id) !== 'demo';
                  });
                } else {
                  ElMessage({
                    message: data.data.msg,
                    type: 'error'
                  });
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getCompanyList() {
        return _ref2.apply(this, arguments);
      };
    }(); // 获取企业基本信息


    var getCompanyData = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return store.dispatch('company/checkCompanyAdmin', {
                  corporation_id: corporationId.value
                });

              case 2:
                // tob: 非企业管理员无法访问企业详情页
                if (onlyAdminSetting && !isAdmin.value) {
                  ElMessage({
                    message: updateCompanyTip.notAdmin,
                    type: 'error'
                  });
                }

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getCompanyData() {
        return _ref3.apply(this, arguments);
      };
    }(); // 切换公司


    var switchCompany = function switchCompany(id) {
      corporationId.value = id;
      location.href = genHrefOpenUrlNoDecode("/company/".concat(id, "/basic"));
    };

    var getAppActiveDetail = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _data$data2;

        var data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return dispatchAction('company', 'getAppActiveDetail', {
                  corporationId: corporationId.value
                });

              case 2:
                data = _context3.sent;

                if (((_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.code) !== 1) {
                  ElMessage({
                    message: data.data.msg,
                    type: 'error'
                  });
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function getAppActiveDetail() {
        return _ref4.apply(this, arguments);
      };
    }();

    var activateApp = function activateApp(appkey) {
      getAppActiveDetail();
    };

    var selectMenu = function selectMenu(key, item) {
      selectedKey.value = key;

      if ((item === null || item === void 0 ? void 0 : item.length) <= 1) {
        router.push({
          name: key,
          params: {
            project: key
          }
        });
      } else {
        router.push({
          name: item[0],
          params: {
            appKey: key,
            type: key
          }
        });
      }
    };

    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var _route$params$company;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              selectedKey.value = route.params.appKey || route.name;
              corporationId.value = ((_route$params$company = route.params.company_id) === null || _route$params$company === void 0 ? void 0 : _route$params$company.toString()) || '';
              getCompanyData();
              getCompanyList();
              store.dispatch('company/getCompanyInfo', {
                corporation_id: corporationId.value
              });
              getAppActiveDetail();
              router.push({
                name: 'Basic'
              });

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    return function (_ctx, _cache) {
      var _component_el_popover = _resolveComponent("el-popover");

      var _component_el_menu_item = _resolveComponent("el-menu-item");

      var _component_MailOutlined = _resolveComponent("MailOutlined");

      var _component_el_sub_menu = _resolveComponent("el-sub-menu");

      var _component_el_menu = _resolveComponent("el-menu");

      var _component_router_view = _resolveComponent("router-view");

      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['company-home', isInMicroApp.value && 'company-home-inMicro', isInCloud.value && 'company-home-inCloud'])
      }, [isInCloud.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4)) : (_openBlock(), _createElementBlock("h2", _hoisted_5, "企业设置")), _unref(isAdmin) || !_unref(onlyAdminSetting) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", {
        class: "title",
        title: _unref(detail).corporation_name
      }, _toDisplayString(_unref(detail).corporation_name), 9, _hoisted_9), _unref(companyData).companyList.length > 1 && !_unref(hideSwitchCorporation) ? (_openBlock(), _createBlock(_component_el_popover, {
        key: 0,
        trigger: "click",
        "popper-class": "company-popover",
        title: "",
        width: "auto",
        placement: "bottom-end",
        teleported: false
      }, {
        reference: _withCtx(function () {
          return [_hoisted_10];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_11, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(companyData).companyList, function (item) {
            return _openBlock(), _createElementBlock("li", {
              class: _normalizeClass({
                current: item.corporation_id === corporationId.value
              }),
              key: item.corporation_id,
              onClick: function onClick($event) {
                return switchCompany(item.corporation_id, item.corporation_name);
              }
            }, [_createElementVNode("span", {
              class: "name",
              title: item.corporation_name
            }, _toDisplayString(item.corporation_name), 9, _hoisted_13)], 10, _hoisted_12);
          }), 128))])])];
        }),
        _: 1
      })) : _createCommentVNode("", true)]), _createVNode(_component_el_menu, {
        style: {
          "width": "248px"
        },
        mode: "vertical",
        "default-active": selectedKey.value,
        "default-openeds": ['App', 'Resource'],
        onSelect: selectMenu
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_menu_item, {
            index: "Basic"
          }, {
            default: _withCtx(function () {
              return [_hoisted_14];
            }),
            _: 1
          }), _unref(showBusiness) ? (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 0,
            index: "Business"
          }, {
            default: _withCtx(function () {
              return [_hoisted_15];
            }),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_sub_menu, {
            index: "App"
          }, {
            icon: _withCtx(function () {
              return [_createVNode(_component_MailOutlined)];
            }),
            title: _withCtx(function () {
              return [_hoisted_16];
            }),
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appList), function (item) {
                return _openBlock(), _createBlock(_component_el_menu_item, {
                  key: item.appKey,
                  index: item.appKey
                }, {
                  default: _withCtx(function () {
                    return [_createElementVNode("span", _hoisted_17, [_createTextVNode(_toDisplayString(item.appName) + " ", 1), _unref(showActivateTag) && item.expiredState === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_18, "已开通")) : _createCommentVNode("", true), _unref(showActivateTag) && item.expiredState === 2 ? (_openBlock(), _createElementBlock("span", _hoisted_19, "即将过期")) : _createCommentVNode("", true)])];
                  }),
                  _: 2
                }, 1032, ["index"]);
              }), 128))];
            }),
            _: 1
          }), _unref(isAdmin) ? (_openBlock(), _createBlock(_component_el_sub_menu, {
            key: 1,
            index: "Resource"
          }, {
            icon: _withCtx(function () {
              return [];
            }),
            title: _withCtx(function () {
              return [_hoisted_20];
            }),
            default: _withCtx(function () {
              return [!_unref(hideUserListRoute) && _unref(isAdmin) ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 0,
                index: "member"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_21];
                }),
                _: 1
              })) : _createCommentVNode("", true), !_unref(hideUserInviteRoute) && _unref(isAdmin) ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 1,
                index: "invite"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_22];
                }),
                _: 1
              })) : _createCommentVNode("", true), _unref(isAdmin) ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 2,
                index: "space"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_23];
                }),
                _: 1
              })) : _createCommentVNode("", true)];
            }),
            _: 1
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["default-active"])]), _createElementVNode("div", _hoisted_24, [_createVNode(_component_router_view)])])) : _createCommentVNode("", true)], 2);
    };
  }
});